import React, { useEffect, useMemo } from 'react';
import { Checkbox, DefaultInputPropTypes, useFormContext, useInputHelper } from 'framework/form';
import { useAuthorization } from 'framework/authorization';
import { CHANGE_OWNER } from 'domain/sales/salesService';
import { READ_FULL_LEADS_LIST } from 'domain/sales/lead/shared/leadService';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';

const LeadOwnerNotificationCheckbox = (props: DefaultInputPropTypes<any>) => {
  const { isGranted } = useAuthorization();
  const hasPermission = isGranted(CHANGE_OWNER) || isGranted(READ_FULL_LEADS_LIST);
  const { data = {} } = useFormContext();
  const { getUserAlias } = useAuthenticatedUserService();
  const initialOwner = useMemo(() => data.ownerAlias, []); // eslint-disable-line react-hooks/exhaustive-deps
  const inputHelper = useInputHelper(props);

  useEffect(() => {
    (async () => {
      const { initializeValue } = inputHelper;
      const alias = await getUserAlias();

      initializeValue(data.ownerAlias !== alias);
    })();
  }, [data.ownerAlias]); // eslint-disable-line react-hooks/exhaustive-deps

  return hasPermission && initialOwner !== data.ownerAlias ? (
    <div className="notification-checkbox">
      <Checkbox {...props} />
    </div>
  ) : null;
};

export default LeadOwnerNotificationCheckbox;
